import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getOrder = (data) => {
  return axios.request({
    url: "/shipments",
    method: "post",
    data,
  });
};

export const getOrderType = () => {
  return axios.request({
    url: "/shipments/status",
    method: "get",
  });
};

// 打印面单
export const postPdf = (data) => {
  return axios.request({
    url: "/go/drawPdf",
    method: "post",
    data,
  });
};
// export const getOrderType = params => {
//   return axios.request({
//     url: "/endpoint/shipments_status",
//     method: "get",
//     params
//   });
// };

export const getOrderDetails = (id) => {
  return axios.request({
    url: `/shipments/info/${id}`,
    method: "get",
  });
};
export const confirmOrder = (data) => {
  return axios.request({
    url: `/shipments/confirmed`,
    method: "put",
    data,
  });
};
export const getOrderStatus = (id) => {
  return axios.request({
    url: `/tracker/trace/getTrace/${id}`,
    method: "get",
  });
};

export const log = (params) => {
  return axios.request({
    url: `/shipments/shipmentLogger`,
    method: "get",
    params
  });
};

export const getOrderStatus1 = (awbno) => {
  return axios.request({
    url: `/tracker/trace/getAllTrace/${awbno}`,
    method: "get",
  });
};
// 双清订单列表
export const getDoubleList = (params) => {
  return axios.request({
    url: `/doubleClearance`,
    method: "get",
    params,
  });
};

export const getError = (params) => {
  return axios.request({
    url: `/shipmentException/exceptionOrder`,
    method: "get",
    params,
  });
};

// 完结异常
export const getFinishError = (data) => {
  return axios.request({
    url: `/shipmentException/updateStatus`,
    method: "post",
    data,
  });
};

// 添加备注
export const addRemark = (data) => {
  return axios.request({
    url: `/shipmentException/inputRemarks`,
    method: "post",
    data,
  });
};

// 备注列表
export const remarkList = (params) => {
  return axios.request({
    url: `/shipmentException/remarksList/`,
    method: "get",
    params,
  });
};

// 获取跟进列表
export const getFollowList = (params) => {
  return axios.request({
    url: `/shipmentException/followUp/${params.airway_number}`,
    method: "get",
    params,
  });
};

// 异常审核
export const checkOrder = (data) => {
  return axios.request({
    url: `/shipmentException/follow`,
    method: "post",
    data,
  });
};

export const getRecord = (id) => {
  return axios.request({
    url: `/shipmentException/getOperationRecord/${id}`,
    method: "get",
  });
};

export function updateSheet(data) {
  return axios.request({
    url: "/overseasOrder/labelUpload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data: data,
  });
}

export const postSheet = (data) => {
  return axios.request({
    url: `/api/batchDrawPdf`,
    method: "post",
    data,
  });
};

export const updateAppointment = (data) => {
  return axios.request({
    url: `/orders/updateAppointment`,
    method: "post",
    data,
  });
};

export const returnPlan = (data) => {
  return axios.request({
    url: `/shipments/returnPlan/${data.id}`,
    method: "put",
    data,
  });
};

export const returnOrderPlan = (data) => {
  return axios.request({
    url: `/shipments/orderReturn`,
    method: "post",
    data,
  });
};

export const returnOpte = (data) => {
  return axios.request({
    url: `/shipments/trackingNumber/${data.id}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data: data.formData,
  });
};

export const getReturn = (params) => {
  return axios.request({
    url: `/shipments/returnList`,
    method: "get",
    params,
  });
};

export const getTimeType = () => {
  return axios.request({
    url: `/shipments/timeType`,
    method: "get",
  });
};

export const confirmWeight = (data) => {
  return axios.request({
    url: `/warehouse/shipments/confirm`,
    method: "post",
    data,
  });
};

//入库单检测
export const checkWeight = (data) => {
  return axios.request({
    url: `/warehouse/shipments/checkWeight`,
    method: "post",
    data,
  });
};

// 新异常订单列表
export const getNewError = (params) => {
  return axios.request({
    url: `/shipmentException/exceptionList`,
    method: "post",
    params,
  });
};

// 新增订单备注
export const addNewRemark = (data) => {
  return axios.request({
    url: `/shipments/batchRemarks`,
    method: "post",
    data,
  });
};

// 获取目的国
export const getAwbCountry = (params) => {
  return axios.request({
    url: `/common/country/getAwbCountry`,
    method: "get",
    params,
  });
};

// 新建异常订单
export const createException = (data) => {
  return axios.request({
    url: "/shipmentException/createException",
    method: "post",
    data,
  });
};
// 批量新建异常订单
export const createExceptionBatch = (data) => {
  return axios.request({
    url: "/shipmentException/batchCreateException",
    method: "post",
    data,
    isNoMsg: true
  });
};

// 获取其他费用
export const getOtherFee = () => {
  return axios.request({
    url: `/common/warehouseService`,
    method: "get",
  });
};

// 新增其他费用
export const addOtherFee = (data) => {
  return axios.request({
    url: `/shipments/addService`,
    method: "post",
    data,
  });
};

// 获取海外仓备注
export const getRemark = (params) => {
  return axios.request({
    url: `/shipments/overseaRemarksList`,
    method: "get",
    params,
  });
};

// 自提
export const getSelf = (data) => {
  return axios.request({
    url: `/shipmentException/kfBatchSetplan`,
    method: "post",
    data,
  });
};

// 批量审核
export const batchAudit = (data) => {
  return axios.request({
    url: `/shipmentException/followBatch`,
    method: "post",
    data,
  });
};

// 处理方案
export const set_plan1 = (data) => {
  return axios.request({
    url: "/shipmentException/kfSetPlan",
    method: "post",
    data,
  });
};

export const batchDelOrder = (data) => {
  return axios.request({
    url: "/shipments/batchDelOrder",
    method: "post",
    data,
  });
};


export const blockOrder = data => {
  return axios.request({
    url: `/shipments/block`,
    method: "put",
    data
  });
};

export const unbox = (data) => {
  return axios.request({
    url: "/shipments/unbox",
    method: "post",
    data,
  });
};

export const removeBlocks = (data) => {
  return axios.request({
    url: "/shipments/removeBlocks",
    method: "post",
    data,
  });
};

export const changeTemuAccount = (data) => {
  return axios.request({
    url: `/shipments/changeTemuAccount`,
    method: "post",
    data,
  });
};

export const getInboundProof = (data) => {
  return axios.request({
    url: `/shipments/inboundProof`,
    method: "get",
    data
  })
}
